if (!window.EcoScentNewAnnouncementBar) {
  window.EcoScentNewAnnouncementBar = {
    sectionSelector: '.new-announcement-bar-section',

    storageKeyFor: function (bar) {
      return 'new_announcement_bar_closed_' + (bar.dataset.sectionId || 'default');
    },

    hideBar: function (bar) {
      bar.classList.add('is-hidden');
    },

    wasDismissed: function (bar) {
      try {
        return !!sessionStorage.getItem(window.EcoScentNewAnnouncementBar.storageKeyFor(bar));
      } catch (error) {
        return false;
      }
    },

    rememberDismissal: function (bar) {
      try {
        sessionStorage.setItem(window.EcoScentNewAnnouncementBar.storageKeyFor(bar), '1');
      } catch (error) {
        return;
      }
    },

    initSection: function (bar) {
      const namespace = window.EcoScentNewAnnouncementBar;
      if (bar.dataset.newAnnouncementBarReady === 'true') return;

      const closeButton = bar.querySelector('[data-new-announcement-bar-close]');
      if (!closeButton) return;

      bar.dataset.newAnnouncementBarReady = 'true';

      if (namespace.wasDismissed(bar)) namespace.hideBar(bar);

      closeButton.addEventListener('click', function () {
        namespace.hideBar(bar);
        namespace.rememberDismissal(bar);
      });
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentNewAnnouncementBar;
      (root || document).querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentNewAnnouncementBar.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentNewAnnouncementBar;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { namespace.initAllSections(); });
      } else {
        namespace.initAllSections();
      }
      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentNewAnnouncementBar.listen();
}
